import React from 'react';
import { useAssessment } from '../../context/AssessmentContext';
import { useDialog } from '../../context/DialogContext';
import styles from '../../styles/assessmentFlow.module.css';
import { t } from '../../i18n/translate';

const WelcomeScreen: React.FC = () => {
  const { dispatch } = useAssessment();
  const { showHelp } = useDialog();

  const handleStartAssessment = () => {
    dispatch({ type: 'SET_CURRENT_STEP', payload: 'levelA' });
  };

  const showSafetyInfo = () => {
    showHelp({
      title: t('self_assess.safety.title'),
      content: t('self_assess.safety.content'),
    });
  };

  return (
    <div className={styles.welcomeScreen}>
      <div className={styles.welcomeContent}>
        <div className={styles.welcomeActions}>
          <button
            onClick={handleStartAssessment}
            className={styles.startButton}
            type="button"
          >
            Begin Assessment
          </button>
        </div>

        <div className={styles.welcomeInfo}>
          <p>
            Many people wonder whether their struggles are "bad enough" or what kind of problem they have. 
            This short self-assessment isn't a diagnosis — it's a way to reflect on patterns in your life 
            and explore recovery options that might help.
          </p>
          
          <p>
            You'll answer some general questions first, then choose specific areas you'd like to explore further. 
            The process takes about 5-10 minutes and is completely private.
          </p>

          <div className={styles.safetyNotice}>
            <button 
              onClick={showSafetyInfo}
              className={styles.safetyButton}
              type="button"
            >
              ⚠️ Safety & Support Information
            </button>
          </div>


        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
